<div class="menu" [class.open]="isMenuOpen">
    <!-- Logo + burger share one fixed-height row, so expanding the mobile
         panel below them cannot shift the logo. -->
    <div class="bar-row">
        <img src="assets/images/homepage/fyes-logo-white.png" alt="" (click)="goTo('')" class="cursor-pointer">

        <!-- Right: Burger Icon (mobile) -->
        <div class="burger" [class.open]="isMenuOpen" (click)="toggleMenu()">
            <span></span>
            <span></span>
            <span></span>
        </div>
    </div>

    <div class="menu-items gap-3" [class.open]="isMenuOpen">
        <a (click)="scrollToSection('cards-section')">{{ 'nav_what_we_do' | translate }}</a>
        <a (click)="scrollToSection('tabs-section')">{{ 'nav_solutions' | translate }}</a>
        <a (click)="scrollToSection('projects-section')">{{ 'nav_case_studies' | translate }}</a>
        <a (click)="goTo('about-us')">{{ 'nav_about_us' | translate }}</a>
        <a (click)="goTo('contact')">{{ 'nav_contact' | translate }}</a>
    </div>

    <div class="right-area">
        @if (session.isLoggedIn()) {
            <div class="account-menu" [class.open]="isAccountOpen">
                <button class="account-btn" (click)="toggleAccount()">{{ 'account_menu' | translate }} <fa-icon [icon]="faChevronDown" class="caret"></fa-icon></button>
                <div class="account-dropdown">
                    @if (session.isAdmin()) {
                        <a (click)="goTo('gateways')">{{ 'account_gateways' | translate }}</a>
                        <a (click)="goTo('dashboard')">{{ 'account_orders' | translate }}</a>
                    } @else if (session.canAccessOrders()) {
                        <!-- Sales: the dashboard and nothing else -->
                        <a (click)="goTo('dashboard')">{{ 'account_orders' | translate }}</a>
                    } @else if (session.isLocal()) {
                        <!-- Legacy usr/main.php menu: User details · Files · Logout -->
                        <a (click)="goTo('my-files')">{{ 'account_files' | translate }}</a>
                        <a (click)="goTo('account')">{{ 'account_details' | translate }}</a>
                    } @else {
                        <!-- Legacy usr/main_gw.php menu: User details · Gateways · Logout -->
                        <a (click)="goTo('gateways')">{{ 'account_gateways' | translate }}</a>
                        <a (click)="goTo('account')">{{ 'account_details' | translate }}</a>
                    }
                    <a (click)="logout()">{{ 'account_logout' | translate }}</a>
                </div>
            </div>
        } @else {
            <div class="login-area">
                <span class="login-link" (click)="openAuth('login')">{{ 'auth_login' | translate }}</span>
                <button class="white-btn" (click)="openAuth('signup')">{{ 'auth_sign_up' | translate }}</button>
            </div>
        }
        <!-- Same open/close model as the account menu above: hover on desktop,
             click-to-expand inline on mobile. -->
        <div class="lang-menu" [class.open]="isLangOpen">
            <button class="lang-btn" (click)="toggleLang()">{{ selectedLangLabel }} <fa-icon [icon]="faChevronDown" class="caret"></fa-icon></button>
            <div class="lang-dropdown">
                @for (lang of languages; track lang.code) {
                    <a [class.active]="lang.code === selectedLang" (click)="changeLanguage(lang.code)">{{ lang.label }}</a>
                }
            </div>
        </div>
    </div>
</div>